module.exports = __webpack_public_path__ + "static/media/chubby.7449d5f4.jpg";